import { render, staticRenderFns } from "./AppPageFootBar_mobile.vue?vue&type=template&id=f51cd46c&scoped=true&"
import script from "./AppPageFootBar_mobile.vue?vue&type=script&lang=js&"
export * from "./AppPageFootBar_mobile.vue?vue&type=script&lang=js&"
import style0 from "./AppPageFootBar_mobile.vue?vue&type=style&index=0&id=f51cd46c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51cd46c",
  null
  
)

export default component.exports